import { ReactComponent as OutlineClock } from "assets/svg/outline-clock.svg";
import { ComponentPropsWithoutRef, useState } from "react";
import { FormControl, InputGroup } from "react-bootstrap";
import getClasses from "utils/getClasses";
import styles from "./FormControlTime.module.scss";
import TimeDropdown from "./time-dropdown/TimeDropdown";

type Props = Omit<
  ComponentPropsWithoutRef<typeof FormControl>,
  "type" | "className"
> & {
  className?: ComponentPropsWithoutRef<typeof InputGroup>["className"];
  inputClass?: ComponentPropsWithoutRef<typeof FormControl>["className"];
};
const FormControlTime = ({
  className,
  inputClass,
  onBlur,
  min = "00:00",
  max = "23:59",
  ...props
}: Props) => {
  const [isShowingDropdown, setIsShowingDropdown] = useState(false);

  const handleBlur = (e) => {
    onBlur?.(e);

    if (isShowingDropdown) {
      return;
    }

    if (e.target.value < min) {
      e.target.value = min;
      props.onChange?.({ target: { value: min } });
    }

    if (e.target.value > max) {
      e.target.value = max;
      props.onChange?.({ target: { value: max } });
    }
  };

  return (
    <InputGroup className={getClasses(styles["form-control-time"], className)}>
      <FormControl
        className={getClasses(
          styles["form-control-time__input"],
          inputClass,
          isShowingDropdown &&
            styles["form-control-time__input--showing-dropdown"],
        )}
        type={"time"}
        onBlur={handleBlur}
        min={min}
        max={max}
        {...props}
      />
      <InputGroup.Text
        className={getClasses(
          styles["form-control-time__append"],
          styles["form-control-time__clock"]
        )}
      >
        <OutlineClock
          className={styles["form-control-time__clock-icon"]}
          onClick={() => setIsShowingDropdown((prev) => !prev)}
        />
        {isShowingDropdown && (
          <TimeDropdown
            value={props.value}
            min={min}
            max={max}
            onChange={props.onChange}
            onClickOutside={() => setIsShowingDropdown(false)}
          />
        )}
      </InputGroup.Text>
    </InputGroup>
  );
};

export default FormControlTime;
